<template>
  <Preparing v-if="isPreparing" />
  <div v-if="!isPreparing">
    <div class="container container-ticket">
      <div class="dashboard-message-wrapper my-4">
        <!-- message-sidebar -->
        <div class="message-content flex-grow-1">
          <div
            class="message-header bg-gray d-flex align-items-center justify-content-between p-4 border-bottom border-bottom-gray">
            <div class="media media-card align-items-center">
              <span class="text-success ticketTitle">عنوان تیکت: </span>
              <span>&nbsp{{ ticket.Title }}</span>
              &nbsp &nbsp &nbsp &nbsp
              <span class="text-info ticketTitle">وضعیت تیکت: </span>
              <span v-if="!ticketDeleted"> &nbsp{{ calcTicketStatus() }}</span>
              <span v-if="ticketDeleted" class="before-price"> حذف شده</span>
            </div>

            <div class="d-flex justify-content-center">
              <div class="icon-element icon-element-sm shadow-sm cursor-pointer mr-3" data-toggle="modal"
                data-target="#closeModal" data-placement="top" title="تیکت را ببندید">
                <i class="la la-close" style="color: red"></i>
              </div>
              <div @click="goBack()" class="icon-element icon-element-sm shadow-sm cursor-pointer mr-3"
                data-placement="top" title="بازگشت به صفحه قبل">
                <i class="la la-arrow-left d-flesx justify-content-center" style="color: #358ff7"></i>
              </div>
            </div>
          </div>

          <!-- message-header -->
          <div class="conversation-wrap">
            <div v-for="t in ticketDetail" :key="t.Id" class="converssation-box custom-scrollbar-styled px-5 py-3">
              <div class="conversation-item mb-3" :class="whoSent(t)">
                <div class="media-card align-items-center">
                  <div v-if="parseInt(t.Type) !== 0" class="flex-shrink-0 mr-0 mb-2 fs-8" :style="isLeft(t)">
                    <span class="pr-2">{{
                      parseInt(t.Type) === 0 ? me.Name : "پشتیبان"
                    }}</span>
                    <img :width="32" :height="32" class="rounded-full img-fluid"
                      src="../assets/images/online-support.png" />
                  </div>
                  <div v-else class="flex-shrink-0 pr-2 mb-2 fs-8" :style="isLeft(t)">
                    <img :width="32" :height="32" class="rounded-full img-fluid" src="../assets/images/man.png" />
                    <span class="pl-2">{{
                      parseInt(t.Type) === 0 ? me.Name : "پشتیبان"
                    }}</span>
                  </div>

                  <div class="media-body d-flex align-items-center">
                    <div class="message-body">
                      {{ t.Content }}
                      <div></div>
                      <a :href="domain + t.File"><button :class="fileColor(t)" v-if="t.File !== 'no' && t.File"
                          type="button" class="btn mt-4 mb-2">
                          <a :style="parseInt(t.Type) !== 0 ? 'color:black;' : ''" :href="domain + t.File">
                            <p style="font-size: 12px">دانلود فایل</p>
                          </a>
                        </button></a>
                      <span class="fs-12 d-block lh-18 pt-1">
                        {{ parseDatest(t.Date)
                        }}<i class="la la-check ml-1"></i></span>
                    </div>
                    <div class="generic-action-wrap generic--action-wrap-3">
                      <div v-if="parseInt(t.Type) === 0" class="dropdown">
                        <a class="action-btn" href="#" role="button" id="dropdownMenuLinkFour" data-toggle="dropdown"
                          aria-haspopup="true">
                          <i class="la la-ellipsis-v"></i>
                        </a>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuLinkFour">
                          <a @click="deleteDetailTicket(t)" class="dropdown-item m-0">حذف</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="progresaa">
              <div class="bg-info" :style="calcProgress()" style="height: 2px" role="progressbar"></div>
            </div>
          </div>
          <div class="message-reply-body d-flex align-items-center pt-2 px-4 border-top border-top-gray">
            <form class="col-lg-12">
              <div class="casrd carsd-item">
                <div class="carsd-body">
                  <div class="form-row">
                    <div class="col-lg-8 form-group">
                      <textarea required v-model="newSent.Content" class="col-lg-12 form-control-textarea"
                        placeholder="پیام خود را اینجا بنویسید..." rows="3"></textarea>
                    </div>
                    <div class="col-lg-4 form-group">
                      <div class="file-upload-wrap file-upload-wrap-ticket">
                        <input onfocus="this.removeAttribute('readonly');" readonly v-on:keyup.enter="replayTicket()"
                          ref="inputFile" accept="application/pdf,application/vnd.ms-excel,.docx,.doc,image/*" type="file"
                          v-on:change="handleFileUpload($event)" class="file-upload-input" />
                        <span class="file-upload-text"><i class="la la-cloud-upload mr-2 fs-18"></i>فایل تیکت</span>
                      </div>
                    </div>
                    <div class="col-lg-12 form-group d-flex align-items-center justify-content-start">
                      <button @click="replayTicket()" :disabled="working" type="button"
                        class="btn theme-btn theme-btn-new-ticket">
                        <div v-if="!working">ارسال تیکت</div>
                        <div v-if="working" class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade modal-container" id="closeModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">بستن تیکت</h3>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div style="border: none !important"
                class="justify-content-center list-group-item list-group-item-action d-flex">
                <div class="text-center d-flex justify-content-center">
                  <div class="course-overview-card">
                    <h2 class="txtRight fs-14 font-weight-regular pb-3">
                      <h4 class="d-flex justify-content-center">هشدار</h4>
                      با انجام این کار‌‌ تیکت بسته خواهد شد! آیا مطمئن هستید؟
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button @click="closeTicket()" type="button" class="btn theme-btn" style="background-color: #358ff7"
              data-dismiss="modal">
              بله
            </button>
            <button type="button" class="btn theme-btn" style="background-color: #f00" data-dismiss="modal">
              خیر
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Toast position="top-left" />
</template>

<script>
import Preparing from "../components/Preparing.vue";

import { donePapersFilters, articleFilters, ticketClientStatuses } from "../constants";
import axios from "axios";
import ls from "localstorage-slim";
import { DOMAIN } from "../configs";
import CkEditor from "../components/CkEditor.vue";
import { FilterMatchMode } from "primevue/api";
var moment = require("jalali-moment");
moment().locale("fa").format("YYYY/M/D");

export default {
  name: "TicketDetail",
  data() {
    return {
      ticketDeleted: false,
      isPreparing: true,
      domain: DOMAIN,
      days: [],
      ticketClientStatuses: ticketClientStatuses,
      newSentFile: "",
      working: false,
      newSent: {},
      ticket: {},
      ticketDetail: [],
      sentticketDetail: [],
      replyticketDetail: [],
      me: {},
      uploadTicketProgress: 0,
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    fileColor(t) {
      if (parseInt(t.Type) !== 0) {
        return "theme-btn-ticket-file-manager";
      } else {
        return "theme-btn-ticket-file-client";
      }
    },

    whoSent(t) {
      if (parseInt(t.Type) !== 0) {
        return "message-reply";
      } else {
        return "message-sent";
      }
    },
    isLeft(t) {
      if (parseInt(t.Type) === 0) {
        return "";
      } else {
        return "float:left !important;";
      }
    },
    async getTicketDetail() {
      await axios
        .post("/api/v1/teacher/ticket/detail", {
          tid: this.ticket.Id,
          mobile: this.me.Mobile,
        })
        .then((response) => {
          if (response.status === 200) {
            this.ticketDetail = response.data;
            this.sentticketDetail = this.ticketDetail.filter(
              (t) => parseInt(t.Type) === this.me.Id
            );
            this.replyticketDetail = this.ticketDetail.filter(
              (t) => parseInt(t.Type) === 0
            );
            this.isPreparing = false;
          }
        });
    },
    async replayTicket() {
      if (this.newSent.Content === undefined) {
        this.$toast.add({
          severity: "error",
          summary: "لطفا پاسخ خود را وارد کنید",
          life: 5000,
        });
        return;
      }
      this.working = true;
      let formData = new FormData();

      formData.append("tid", this.ticket.Id);
      formData.append("File", this.newSentFile[0]);
      formData.append("title", this.ticket.Title);
      formData.append("paperid", 0);
      formData.append("productname", "-");
      formData.append("type", 0);
      formData.append("userid", this.ticket.UserId);
      formData.append("username", this.ticket.UserName);
      formData.append("mobile", this.me.Mobile);
      formData.append("name", this.me.Name);
      formData.append("dpid", 0);
      formData.append("content", this.newSent.Content);
      await axios
        .post("/api/v1/teacher/ticket/replay", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.uploadTicketProgress = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then((response) => {
          if (response.status === 200) {
            this.getTicketDetail();
            this.$toast.add({
              severity: "success",
              summary: "تیکت با موفقیت پاسخ داده شد",
              life: 5000,
            });
            this.$refs.inputFile.value = null;
            this.newSent.Content = "";
            this.uploadTicketProgress = 0;
            this.working = false;
          }
        });
    },
    async deleteDetailTicket(dt) {
      await axios
        .post("/api/v1/teacher/ticket/delete/detail", {
          id: dt.Id,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "عملیات با موفقیت انجام شد",
              life: 5000,
            });
            this.getTicketDetail();
          } else {
            this.$toast.add({
              severity: "error",
              summary: "خطا در عملیات، لطفا مجدد تلاش کنید",
              life: 5000,
            });
          }
        });
    },
    async closeTicket() {
      await axios
        .post("/api/v1/teacher/ticket/close", {
          tid: this.ticket.Id,
        })
        .then((response) => {
          if (response.status === 200) {
            this.goBack()
            this.$toast.add({
              severity: "success",
              summary: "عملیات با موفقیت انجام شد",
              life: 5000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "خطا در عملیات، لطفا مجدد تلاش کنید",
              life: 5000,
            });
          }
        });
    },

    handleFileUpload(event) {
      if (event.target.files[0].size > 10000000) {
        this.$toast.add({
          severity: "error",
          summary: "خطا در ثبت پروژه",
          detail: "حداکثر حجم فایل قابل قبول 10 مگابایت است",
          life: 5000,
        });
        return;
      }
      this.newSentFile = event.target.files;
    },
    calcProgress() {
      var res = this.uploadTicketProgress;
      var ress = `width:${res}%;`;
      return ress;
    },
    calcTicketStatus() {
      let st = this.ticket.Status;
      return this.ticketClientStatuses.find((s) => s.code === st).name;
    },
  },
  async beforeMount() {
    this.me = JSON.parse(ls.get("user"));
    this.ticket = ls.get("viewingTicket");
    await this.getTicketDetail();

  },
};
</script>

<style></style>
